/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import HelpTooltip from "components/HelpTooltip";

function FormField({ label, helpText, ...rest }) {
  return (
    <MDBox mb={2} display="flex" alignItems="flex-start" gap={1}>
      <MDInput {...rest} variant="standard" label={label} fullWidth sx={{ flex: 1, minWidth: 0 }} />
      {helpText && <HelpTooltip title={helpText} sx={{ mt: 0.25, flex: "0 0 auto" }} />}
    </MDBox>
  );
}

FormField.defaultProps = {
  helpText: "",
};

// typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string.isRequired,
  helpText: PropTypes.string,
};

export default FormField;
